<template>
  <div
    class="relative overflow-hidden rounded-3xl p-6 text-white md:p-4 lg:p-8"
    :class="`bg-${backgroundGradient}`">
    <NuxtImg
      v-if="backgroundImage && isDesktop"
      :src="backgroundImage"
      :alt="title || ''"
      class="pointer-events-none absolute inset-0 h-full w-full object-cover"
      sizes="xs:87vw sm:786px md:1024px lg:1140px xl:1140px xxl:1140px"
      loading="lazy" />
    <NuxtImg
      v-else-if="backgroundImage || backgroundImageMobile"
      :src="backgroundImageMobile ? backgroundImageMobile : backgroundImage"
      :alt="title || ''"
      class="pointer-events-none absolute inset-0 h-full w-full object-cover"
      sizes="xs:87vw sm:786px md:1024px lg:1140px xl:1140px xxl:1140px"
      loading="lazy" />

    <div class="relative flex h-full flex-col justify-between">
      <div
        class="max-w-[320px]"
        :class="{
          'md:max-w-xl': wide
        }">
        <h3
          class="text-3xl font-medium"
          :class="{
            'md:text-4xl': wide // If the card is the only one in the row, make the title bigger on desktop
          }">
          {{ title }}
        </h3>
        <div
          v-if="copy"
          class="prose prose-lg mt-4 text-base text-white prose-strong:text-white"
          v-html="copy" />
      </div>

      <div
        v-if="cta"
        class="mt-36 flex text-base md:text-lg"
        :class="[backgroundImage ? 'sm:mt-32' : 'sm:mt-16']">
        <ButtonBase
          class="mt-2"
          :type="cta.type"
          :href="cta.href"
          :label="cta.title"
          :href-type="cta.download ? 'download' : null"
          @click="handleClick()" />
      </div>

      <div
        v-else
        class="mt-24" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router'
  import { useNuxtApp } from '#imports'

  import { useScreenSize } from '~/composables/use-screen-size'

  import type { CtaType } from '../../models/button'

  type CardGradientProps = {
    title: string
    copy?: string
    cta: CtaType
    wide: boolean
    backgroundImage?: string
    backgroundGradient?: string
    backgroundImageMobile?: string
  }

  const props = defineProps<CardGradientProps>()

  const { isDesktop } = useScreenSize()

  const { $event } = useNuxtApp()
  const route = useRoute()

  function handleClick() {
    if (route.path.includes('partners')) {
      return $event('Contact', { props: { 'Partners page': props.title } })
    }
    if (route.path.includes('contact-us')) {
      return $event('Contact', { props: { 'Contact us page': props.title } })
    }
  }
</script>
